import { render, staticRenderFns } from "./CardBuilder.vue?vue&type=template&id=8d40e71e&scoped=true"
import script from "./CardBuilder.vue?vue&type=script&lang=js"
export * from "./CardBuilder.vue?vue&type=script&lang=js"
import style0 from "./CardBuilder.vue?vue&type=style&index=0&id=8d40e71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d40e71e",
  null
  
)

export default component.exports